// --- DEBUG import (temporary; remove with the debug logging below) ---
import Cookies from 'js-cookie';

import apiClient from '../middleware/apiClient';

// import { formatFetchNewLabelPayload } from '../helpers/order';
import { DSM_DEVICES, COTTON_DSM_DEVICES, COTTON_V1_DSM_DEVICES } from '../helpers/apis';
import { callApiWithFallback } from '../helpers/apiFallback';
import { kibanaLog, getGuid } from '../helpers/logger';
import cottonFlagManager from '../helpers/featureFlags/cotton';
// --- DEBUG imports (temporary; remove with the debug logging below) ---
import { lowerEnvConsoleLog, lowerEnvConsoleWarn } from '../helpers/lowerEnvConsoleLog';
import { isReady } from '../helpers/featureFlags';
import { getUserSegment } from '../helpers/segmentation';

// Fetch Returns
export const FETCH_DEVICES = 'FETCH_DEVICES';
export const FETCH_DEVICES_SUCCESS = 'FETCH_DEVICES_SUCCESS';
export const FETCH_DEVICES_FAILURE = 'FETCH_DEVICES_FAILURE';
export const RESET_DEVICES = 'RESET_DEVICES';

function fetchDevices(endpoint = DSM_DEVICES) {
  return {
    type: FETCH_DEVICES,
    payload: apiClient.fetch(endpoint),
  };
}

function fetchDevicesSuccess(returns) {
  return {
    type: FETCH_DEVICES_SUCCESS,
    payload: returns,
  };
}

function fetchDevicesFailure(error) {
  return {
    type: FETCH_DEVICES_FAILURE,
    payload: error,
  };
}

const mergeDevices = (ssmDevices, convoyDevices) => {
  const devs = {};
  Object.keys(ssmDevices).forEach((lob) => {
    // SSM now passes `accountNumber` on this object for some reason -_-.
    if (!Array.isArray(ssmDevices[lob])) return;
    ssmDevices[lob].forEach((ssmDevice) => {
      const convoyDevice = convoyDevices[ssmDevice.serialNumber] || {};
      const convoyLob = convoyDevice.lob || lob;
      devs[convoyLob] = devs[convoyLob] || [];
      let { friendlyName } = convoyDevice;
      const { x1 } = convoyDevice;
      let title;
      if (convoyLob === 'video') {
        title = x1 ? 'X1 TV Box' : 'TV Box';
      } else if (convoyLob === 'storeFront') {
        title = 'Streaming TV Box';
      } else if (convoyLob === 'internet' && convoyDevice?.gatewayType === 'ADVANCED_MODEM') {
        title = 'Advanced Modem';
      } else {
        title = (
          friendlyName
          || `${convoyLob.substring(0, 1).toUpperCase()
          }${convoyLob.substring(1)
          } Device`
        );
        friendlyName = '';
      }
      devs[convoyLob].push({
        ...ssmDevice,
        friendlyName,
        title,
      });
    });
  }, {});
  return devs;
};

export const getReturnableDevices = () => async (dispatch, getState) => {
  const {
    devices: {
      services, cacheValid, requested, loading,
    } = {},
  } = getState();
  if (cacheValid) {
    return services;
  }
  try {
    let response;
    const { isAptV1Enabled, dsmDevicesEnabled } = cottonFlagManager;

    // --- DEBUG: prove flag-evaluation/timing state at the devices decision point ---
    const debugSnapshot = {
      api: 'dsm_devices',
      guid: String(getGuid()),
      // in-flight / double-dispatch proof
      in_flight_requested: String(requested),
      in_flight_loading: String(loading),
      in_flight_cache_valid: String(cacheValid),
      overlapping_call: String(Boolean(requested) && !cacheValid),
      // flag-readiness (timing) proof
      flags_ready: String(isReady()),
      decision_before_flags_ready: String(!isReady()),
      // evaluated gating chain
      master_flag: String(cottonFlagManager.masterFlag),
      cotton_allowed: String(cottonFlagManager.cottonAllowed),
      is_base_enabled: String(cottonFlagManager.isBaseEnabled),
      is_apt_v1_enabled: String(isAptV1Enabled),
      dsm_devices_enabled: String(dsmDevicesEnabled),
      disable_ruby_apis: String(cottonFlagManager.disableRubyApis),
      // cookies / segmentation (rule-out fields)
      cotton_allowed_cookie: String(Cookies.get('cotton_allowed')),
      xf_seg_cookie: String(Cookies.get('xf_seg')),
      user_segment: String(getUserSegment()),
    };
    lowerEnvConsoleLog('[DEBUG dsm_devices gating]', debugSnapshot);
    kibanaLog('debug_dsm_devices_gating', debugSnapshot);
    // --- END DEBUG ---

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('apt_v1_dsm_devices_api_called');
      response = await dispatch(fetchDevices(COTTON_V1_DSM_DEVICES)).payload;
    } else if (dsmDevicesEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => fetchDevices(COTTON_DSM_DEVICES), // Cotton API call
        () => fetchDevices(DSM_DEVICES), // Ruby API call
        'dsm_devices',
      );
    } else {
      // Only call Ruby API
      // --- DEBUG: direct Ruby branch => cotton flags evaluated false at request time ---
      lowerEnvConsoleWarn('[DEBUG dsm_devices] RUBY-ONLY branch taken (cotton flags false)', debugSnapshot);
      kibanaLog('debug_dsm_devices_ruby_only_branch', debugSnapshot);
      // --- END DEBUG ---
      response = await dispatch(fetchDevices(DSM_DEVICES)).payload;
    }
    const { account: { devices: { bySerial } } } = getState();
    const payload = mergeDevices(response, bySerial);
    dispatch(fetchDevicesSuccess(payload));
    return payload;
  } catch (error) {
    dispatch(fetchDevicesFailure(error));
    throw error;
  }
};
